import { render, staticRenderFns } from "./MarkerLeaflet.vue?vue&type=template&id=4c8c2a3a&"
import script from "./MarkerLeaflet.vue?vue&type=script&lang=js&"
export * from "./MarkerLeaflet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports